import { IBlogDictionary } from '@/dictionaries/pages/blog/types';
import { cn } from '@/lib/utils';
import { HomeTranslatedBlogArticle, TranslatedBlogArticle } from '@/types/Blog';
import { useMemo } from 'react';
import Slider, { Settings } from 'react-slick';
import BlogArticleListItem from './Item';

const settings: Settings = {
  dots: false,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dotsClass: 'carousel-dots',
  autoplay: true,
  autoplaySpeed: 4000,
};

type Props = {
  dict: IBlogDictionary;
  lang: string;
  className?: string;
  categoryParam?: string;
  articles: HomeTranslatedBlogArticle[];
  isHome?: boolean;
};

export default function HomeBlogArticleList({
  lang,
  dict,
  className,
  articles,
}: Props) {
  let baseArticles: HomeTranslatedBlogArticle[] = articles;

  const blogArticleList = useMemo(
    () =>
      baseArticles.map((article) => (
        <BlogArticleListItem
          key={article.id}
          readMoreLabel={dict.readMore}
          lang={lang}
          article={article}
        />
      )),
    [baseArticles, dict.readMore, lang],
  );

  return (
    <>
      <div className="flex flex-wrap flex-row gap-6">
        <div
          className={cn(
            'flex-nowrap mx-auto md:mx-auto grid-cols-3 gap-8 hidden desktop:grid',
            className,
          )}>
          {blogArticleList}
        </div>
      </div>

      <div className="relative desktop:hidden">
        <Slider className="w-full mx-0" {...settings}>
          {blogArticleList}
        </Slider>
      </div>
    </>
  );
}
